import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import {
  isMobile,
  userInfoStore,
  notificationStore,
  ConnectionPopupsWr,
  UnderMaintenanceContainer,
  useSoundWatcher,
  loadingStore,
} from '@pascal/pascal-core';
import { applicationStore, betStore } from '@pascal/pascal-core/shared/core/store';

import { WebGameWrapper } from '../web';
import { MobileMainWrapper } from '../mobile';
import { gameStore } from '../../store';
import { useVisibilityChange } from '../../hooks';

const GameWebMobileContainer = observer(() => {
  const { isDemo } = applicationStore;

  useVisibilityChange();
  useSoundWatcher();

  useEffect(() => {
    loadingStore.startLoaderTimer();

    return () => {
      if (isDemo) {
        betStore.setDemoBetHistory([]);
        userInfoStore.setDemoInitialBalance();
      }
      gameStore.setIsLoadingPage(true);
      betStore.setLiveBets([]);
      betStore.resetBetHistory();
      notificationStore.setNotificationType(null);
    };
  }, []);

  return (
    <UnderMaintenanceContainer>
      {isMobile() ? <MobileMainWrapper /> : <WebGameWrapper />}
      <ConnectionPopupsWr />
    </UnderMaintenanceContainer>
  );
});

export default GameWebMobileContainer;
